import React from 'react';
import '../../../styles/components/sections/DownloadSection.css';

const DownloadSection = () => {
  return (
    <section id="download" className="download-section">
      <div className="container">
        <h2 className="download-title">Preuzmi aplikaciju i kreni sa pranjem</h2>
        <p className="download-subtitle">Najjednostavniji način da tvoj auto uvek blista.</p>
        
        <div className="badge-wrapper">
          <a href="https://apps.apple.com/rs/app/clickwash/id6749760998" className="badge-link">
            <img src="/images/app_store.svg" alt="App Store" className="clean-badge" />
          </a>
          <a href="https://play.google.com/store/apps/details?id=rs.clickwash.app&hl=en" className="badge-link">
            <img src="/images/google_play.svg" alt="Google Play" className="clean-badge" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default DownloadSection;